// HomePage Constants

// Enhanced prefixes for each category
export const prefixes = {
  learn: 'I want to learn about ',
  stories: 'Tell me a story about ',
  games: 'Let\'s play a game about ',
  riddles: 'Give me a riddle about ',
  art: 'Show me how to draw ',
  science: 'Explain the science behind ',
  fun: 'Show me something fun about ',
  facts: 'Tell me some facts about ',
  math: 'Help me solve math problems on ',
  nature: 'Tell me about '
};

// Enhanced topics per category
export const topics = {
  learn: ['the solar system', 'volcanoes', 'robotics', 'dinosaurs', 'oceans', 'space exploration'],
  stories: ['brave knights', 'magical forests', 'space adventures', 'underwater kingdoms', 'friendly dragons'],
  games: ['word puzzles', 'memory games', 'math challenges', 'science experiments', 'art projects'],
  riddles: ['animals', 'nature', 'everyday objects', 'colors', 'shapes', 'numbers'],
  art: ['animals', 'landscapes', 'space scenes', 'underwater worlds', 'fantasy creatures'],
  science: ['how rainbows form', 'why the sky is blue', 'how plants grow', 'animal adaptations'],
  fun: ['jokes', 'magic tricks', 'dance moves', 'singing songs', 'creative crafts'],
  facts: ['amazing animals', 'incredible inventions', 'famous landmarks', 'space discoveries'],
  math: ['addition', 'subtraction', 'multiplication', 'shapes', 'patterns', 'measurement'],
  nature: ['trees', 'flowers', 'animals', 'weather', 'seasons', 'ecosystems']
};

// Search types configuration
export const searchTypes = [
  { id: 'web', name: 'Web', icon: 'Globe', color: '#667eea' },
  { id: 'game', name: 'Games', icon: 'Gamepad2', color: '#ff6b6b' },
  { id: 'education', name: 'Education', icon: 'BookOpen', color: '#4ecdc4' },
  { id: 'facts', name: 'Facts', icon: 'Lightbulb', color: '#45b7d1' },
  { id: 'images', name: 'Images', icon: 'Image', color: '#96ceb4' },
  { id: 'news', name: 'News', icon: 'Newspaper', color: '#feca57' },
  { id: 'videos', name: 'Videos', icon: 'Video', color: '#ff9ff3' },
];

// Chrome extension promo configuration
export const CHROME_EXTENSION_CONFIG = {
  url: 'https://chromewebstore.google.com/detail/kids-safe-search-engine/fjmiccpdnbjkegppnjkamgbbjpbmgabn?hl=en',
  localStorageKey: 'chromePromoDismissedAt',
  dismissDuration: 86400000, // 24 hours in milliseconds
  desktopBreakpoint: 768,
}; 